import { React } from 'react';
import { useState } from 'react';
import '../styles/components/character.scss'

const Character = (props) => {
    const [current, setCurrent] = useState(0)

    return(
        <div className="character-container">
            <div className="character-select">
                <div className="character-title">
                    <h1 className={`char-title-${props.game}`}>
                        <span>CHARACTERS</span>
                    </h1>
                </div>
                <div className={`character-icons-${props.game}`}>
                {
                    props.charList.map((char)=>{
                        return(
                            <img src={char.head} alt={char.name} className="character-icon" onClick={()=>setCurrent(char.key)} tabIndex='0' />
                        )
                    })
                }
                </div>
            </div>
            <section className="character-wrapper">
            {
            props.charList.map((char)=>{
                return (
                    (char.key === current) && 
                    <div className="color" id={props.game}>
                        <div className='character'>
                            <div className="character-art">
                                <img src={char.img} alt={char.name} />
                            </div>
                            <div className="character-desc">
                                <div className="desc-wrapper">
                                    <h1 className="character-name">
                                        <span>{char.name}</span>
                                    </h1>

                                    {
                                        (props.showStats) && 
                                        <div className="character-stats">
                                            <h2 className="gender"><span>Gender: </span>{char.gender}</h2>
                                            <h2 className="type"><span>Type: </span> {char.type}</h2>
                                            <h2 className="height"><span>Height: </span> {char.height}</h2>
                                            <h2 className="weight"><span>Weight: </span> {char.weight}</h2>
                                            <h2 className="Age"><span>Human Age: </span> {char.age}</h2>
                                            <h2 className="Ability"><span>Ability: </span> {char.ability}</h2>
                                        </div>
                                    }

                                    <p className={`character-bio-${props.game}`}>                                     <span>About: </span> 
                                        {char.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            }
            </section>
        </div>
    );
}

export default Character;